import Vuex from 'vuex'
import Vue from 'vue'
import module_app from './app/'
import module_A from './A'
// import module_B from './B'
import module_C from './C'
import module_D from './D'
import module_E from './E'

import module_H from './H'

// import module_L from './L'
// import module_M from './M'
// import module_N from './N'
// import module_O from './O'
// import module_P from './P'

// import module_S from './S'

import module_X from './X'
// import module_Z from './Z'

Vue.use(Vuex)
const store = new Vuex.Store({
    modules:{
        app: module_app,
        A: module_A,
        // B: module_B,
        C: module_C,
        // P: module_P,
        E: module_E,
        H: module_H,
        // S: module_S,
        // L: module_L,
        // M: module_M,
        // N: module_N,
        // O: module_O,
        D: module_D,
        X: module_X,
        // Z: module_Z,
    }
  })


  export default store